module.exports = __webpack_public_path__ + "media/images/icons/bi-emoji-laughing-435231f36f9d66ef41b4338d56c44ab9.png";